// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"85f2165e","205":"2fa3179f","213":"a1f701b9","276":"84679f9c","283":"70429250","407":"a30574b9","499":"c1f76a55","534":"661352dc","602":"6cc568d7","998":"24b0727b"}[chunkId] + ".chunk.js";
};